import { Layout, Loading, Pagination } from 'element-react';
import { useHistory } from "react-router-dom";
import mainSearchStore from '../store/main-search';
import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { listUserFavoritess, listCompanys, listUsers } from '../graphql/queries';
import { API, graphqlOperation } from 'aws-amplify';
import ResultCard from '../components/ResultCard';
import CompanyResultCard from '../components/CompanyResultCard';
import { useTranslation } from 'react-i18next';
import FilterHeader from '../components/FilterHeader';
import filterSearchStore from '../store/filter-search';
import { Auth } from 'aws-amplify';
import { createUserFavorites, deleteUserFavorites } from '../graphql/mutations';
import userStore from '../store/user';
import { generateProductChat } from '../services/ChatService';
import { CHAT_PRODUCT_MESSAGE } from '../utils/ChatConstants';
import PagerQuery from '../utils/PagerQuery';
import Survey from "./Survey";
import ProductBanner from "../components/ProductBanner";
import SearchSubCategoryDescription from "../components/SearchSubCategoryDescription";
import { SEARCH_URL, SEARCH_COMPANIES_URL } from '../utils/Constants';


let tokenArray = [];

// Función para estandarizar nombres de ubicación
const normalizeState = (rawState) => {
    if (!rawState) return null;
    
    // Limpieza Agresiva:
    // Convertimos a minúsculas y eliminamos comillas, paréntesis, puntos y espacios extra.
    let clean = rawState.toString().toLowerCase()
        .replace(/["().]/g, "") 
        .trim();

    // Diccionario de Mapeo
    
    // CASO: NUEVO LEÓN
    if (['nl', 'nuevo leon', 'nuevo león'].includes(clean)) return 'Nuevo León';
    
    // CASO: CIUDAD DE MÉXICO 
    if (['cdmx', 'ciudad de mexico', 'ciudad de méxico', 'df', 'distrito federal', 'la magdalena contreras'].includes(clean)) return 'Ciudad de México';

    // CASO: ESTADO DE MÉXICO
    // "mexico", "mx", "estado" en el campo de estado suelen ser EdoMex.
    if (['edomex', 'estado de mexico', 'estado de méxico', 'estado', 'mexico', 'méxico', 'mx'].includes(clean)) return 'Estado de México';

    // CASO: CHIHUAHUA
    if (['chih', 'chihuahua'].includes(clean)) return 'Chihuahua';

    // CASO: COAHUILA
    if (['coah', 'coahuila'].includes(clean)) return 'Coahuila';

    // CASO: DURANGO
    if (['durango'].includes(clean)) return 'Durango';

    // CASO: GUANAJUATO 
    if (['guanajuato', 'guanjuato', 'gto'].includes(clean)) return 'Guanajuato';

    // CASO: JALISCO
    if (['jal', 'jalisco'].includes(clean)) return 'Jalisco';

    // CASO: PUEBLA 
    if (['pue', 'puebla', 'puebla mx'].includes(clean)) return 'Puebla';

    // CASO: QUERÉTARO
    if (['qro', 'queretaro', 'querétaro'].includes(clean)) return 'Querétaro';

    // CASO: SAN LUIS POTOSÍ
    if (['slp', 'san luis potosi', 'san luis potosí'].includes(clean)) return 'San Luis Potosí';

    // CASO: SONORA
    if (['sonora', 'son'].includes(clean)) return 'Sonora';

    // CASO: VERACRUZ
    if (['veracruz', 'ver'].includes(clean)) return 'Veracruz';

    // CASO: MORELOS
    if (['morelos', 'mor'].includes(clean)) return 'Morelos';

    // INTERNACIONALES 
    if (clean === 'texas') return 'Texas';
    if (clean === 'new york') return 'New York';
    if (clean === 'latin america') return 'Latin America';
    if (clean === 'otros') return 'Otros';

    // 3. Fallback: Capitalizar primera letra de cada palabra para lo que no esté en la lista
    return clean.replace(/\b\w/g, l => l.toUpperCase());
};

function SearchResultNG() {

    let history = useHistory();
    const { t } = useTranslation();
    const { filterInfo, setFilterInfo,
        clearSelectedCategories, selectedCategories
    } = filterSearchStore();
    const { mainInfo } = mainSearchStore();
    let { query, tag } = useParams();
    const [favorites, setFavorites] = useState([]);
    const [loading, setLoading] = useState(false);
    const [productsState, setProductsState] = useState([]);

    // Estados para Empresas, Pestañas y Filtro de Estado 
    const [companiesState, setCompaniesState] = useState([]);
    const [activeTab, setActiveTab] = useState('products');
    const [totalCompanies, setTotalCompanies] = useState(0);
    const [selectedStates, setSelectedStates] = useState([]); 

    const [total, setTotal] = useState(0);
    const [filterCerts, setFilterCerts] = useState("");
    const { user } = userStore();
    const [page, setPage] = useState(1);
    const [sortBy, setSortBy] = useState('')
    const [viewModalUser, setViewModalUser] = useState(false);
    const [viewSubCategoryDescription, setViewSubCategoryDescription] = useState(false);
    const [titleAndDescription, setTitleAndDescription] = useState({ title: '', description: '' });

    useEffect(() => {
        const handleStateFilter = (event) => {
            console.log("Evento recibido en SearchResultNG: Filtrar por estado", event.detail);
            setSelectedStates(event.detail); 
            setPage(1); 
        };

        window.addEventListener('CMD_FILTER_BY_STATE', handleStateFilter);

        return () => {
            window.removeEventListener('CMD_FILTER_BY_STATE', handleStateFilter);
        };
    }, []);

    // Efecto principal: Se dispara cuando cambia el query, o el selectedState
    useEffect(() => {
        console.log('Searching for...', { mainInfo });
        tokenArray = [];
        setPage(1);
        
        if (activeTab === 'products') {
            getActiveProducts(0); 
            getCompanies(0, []); 
        } else {
            // Si estamos en EMPRESAS:
            getCompanies(0, selectedStates); 
            getActiveProducts(0);
        }
        
        searchUserFavorites();
    }, [query, tag, sortBy,filterInfo.minPrice, filterInfo.pageSize, filterInfo.maxPrice,
        filterInfo.customAllowed, filterInfo.minBuy, filterInfo.warranty,filterCerts, selectedCategories,selectedStates, activeTab 
    ]);

    useEffect(() => {
        clearSelectedCategories();
        return function () {
            clearSelectedCategories();
        };
    }, []);

    const searchUserFavorites = async () => {
        try {
            const u = await Auth.currentAuthenticatedUser();
            let filter = {
                owner: { eq: u.username }
            };
            const result = await API.graphql({ query: listUserFavoritess, variables: { filter } });
            setFavorites(result.data.listUserFavoritess.items);
        } catch (e) {
            console.error(e);
        }
    }

    const addToFavorites = async (productId) => {
        try {
            setLoading(true);
            const u = await Auth.currentAuthenticatedUser();
            const input = {
                userFavoritesProductId: productId
            }
            const result = await API.graphql(
                graphqlOperation(createUserFavorites, { input })
            );
            let favs = favorites;
            favs.push(result.data.createUserFavorites);
            setFavorites(favs);
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
            if (e === 'The user is not authenticated') {
                setViewModalUser(true);
            }
        }
    }

    const removeFromFavorites = async (fav) => {
        try {
            setLoading(true);
            const input = {
                id: fav.id
            }
            await API.graphql(
                graphqlOperation(deleteUserFavorites, { input })
            );
            let favs = favorites.filter(function (obj) {
                return obj.id !== fav.id;
            });
            setFavorites(favs);
            setLoading(false);

        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    }

    const getCompanies = async (_page, _statesFilter = selectedStates) => {
        try {
            const requestBody = {
                searchQuery: "", 
                sortBy: sortBy,
                filterInfo: {
                    ...filterInfo,
                    state: null,
                    pageSize: 2000 
                },
                filterCerts: "" 
            };

            const response = await fetch(SEARCH_COMPANIES_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            });
            
            let data = await response.json();
            if (!Array.isArray(data)) data = []; 

            // Filtrado Base por TEXTO
            if (query && query !== '$EMPTY$' && query.trim() !== "") {
                const qLower = query.toLowerCase();
                data = data.filter(item => {
                    const name = (item.name || item.company_name || "").toLowerCase();
                    //const desc = (item.description || "").toLowerCase();
                    const cat = (typeof item.category === 'string' ? item.category : item.category?.name || "").toLowerCase();
                    const products = [item.promote1, item.promote2, item.promote3].join(" ").toLowerCase();
                    return name.includes(qLower) || cat.includes(qLower) || products.includes(qLower);
                });
            }

            // === LÓGICA DINÁMICA DE FILTROS  ===
            if (activeTab === 'companies') {
                
                // CALCULAR ESTADOS DISPONIBLES
                let dataForStates = data;
                if (selectedCategories.length > 0) {
                    dataForStates = data.filter(item => {
                        const catName = typeof item.category === 'string' ? item.category : item.category?.name;
                        return selectedCategories.includes(catName);
                    });
                }
                const uniqueStates = [...new Set(
                    dataForStates.map(item => {
                        let rawVal = item.address?.state || item.company?.address?.state || item.location?.state;
                        return normalizeState(rawVal);
                    }).filter(state => state && state !== "")
                )].sort();
                
                const event = new CustomEvent('CMD_UPDATE_STATES', { detail: uniqueStates });
                window.dispatchEvent(event);


                // CALCULAR CATEGORÍAS DISPONIBLES
                let dataForCats = data;
                if (Array.isArray(_statesFilter) && _statesFilter.length > 0) {
                    dataForCats = data.filter(item => {
                        let rawVal = item.address?.state || item.company?.address?.state || item.location?.state;
                        const normalizedItemState = normalizeState(rawVal);
                        return _statesFilter.includes(normalizedItemState);
                    });
                }
                let uniqueCategories = Array.from(new Set(
                    dataForCats.map(item => {
                        return typeof item.category === 'string' ? item.category : item.category?.name;
                    }).filter(c => c)
                ));
                uniqueCategories.sort();
                setFilterInfo(filterInfo.pageSize, filterInfo.minPrice, filterInfo.maxPrice, filterInfo.customAllowed, filterInfo.warranty, filterInfo.minBuy, uniqueCategories);
            }
            
            // Filtro Ubicación
            if (Array.isArray(_statesFilter) && _statesFilter.length > 0) {
                data = data.filter(item => {
                    let rawVal = item.address?.state || item.company?.address?.state || item.location?.state;
                    const normalizedItemState = normalizeState(rawVal);
                    return _statesFilter.includes(normalizedItemState);
                });
            }

            // Filtro Categoría
            if (activeTab === 'companies' && selectedCategories.length > 0) {
                data = data.filter(item => {
                    const catName = typeof item.category === 'string' ? item.category : item.category?.name;
                    return selectedCategories.includes(catName);
                });
            }

            // Filtro Certificación
            if (activeTab === 'companies' && filterCerts && filterCerts.trim() !== "") {
                const certQuery = filterCerts.toLowerCase().trim();
                data = data.filter(item => {
                    const allTitles = [item.titles, item.additional_titles1, item.additional_titles2, item.additional_titles3, item.additional_titles4].map(t => (t || "").toLowerCase()).join(" ");
                    return allTitles.includes(certQuery);
                });
            }

            setTotalCompanies(data.length); 
            const realPageSize = filterInfo.pageSize || 10;
            const _arrayPaged = data.slice(_page * realPageSize, (_page * realPageSize) + realPageSize);
            setCompaniesState(_arrayPaged);

        } catch (e) {
            console.error("Error fetching companies", e);
            setCompaniesState([]);
        } 
    }

    const getActiveProducts = async (_page) => {
        setLoading(true);
        try {
            const response = await fetch(SEARCH_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    sortBy: sortBy,
                    filterInfo: filterInfo,
                    filterCerts: "", 
                    searchQuery: query,
                })
            });
            let data = await response.json();
            
            // 1. Filtrado Query (Texto o Tag)
            if (query === '$EMPTY$') {
                let _tags = tag.split('|');
                const _category = _tags[0];
                const _subCategory = _tags[1];
                if (_category != 'all' && _subCategory != 'all') {
                    if (_subCategory === 'All') {
                        data = data.filter(item => item.category_id === _category);
                    } else {
                        data = data.filter(item => item.category_id === _category && item.subcategory_name === _subCategory);
                    }
                }
            }

            // === LÓGICA DINÁMICA DE FILTROS ===
            if (activeTab === 'products') {
                
                // Calcular Categorías (basado en Estados seleccionados)
                let dataForCats = data;
                if (selectedStates.length > 0) {
                    dataForCats = data.filter(item => {
                        let rawVal = item.company?.address?.state || item.company_state;
                        const normalized = normalizeState(rawVal);
                        return selectedStates.includes(normalized);
                    });
                }
                let uniqueCategories = Array.from(new Set(dataForCats.map(item => item.category.name)));
                uniqueCategories.sort();
                setFilterInfo(filterInfo.pageSize, filterInfo.minPrice, filterInfo.maxPrice, filterInfo.customAllowed, filterInfo.warranty, filterInfo.minBuy, uniqueCategories);

                // Calcular Estados (basado en Categorías seleccionadas)
                let dataForStates = data;
                if (selectedCategories.length > 0) {
                    dataForStates = data.filter(item => selectedCategories.includes(item.category.name));
                }
                const uniqueProductStates = [...new Set(
                    dataForStates.map(item => {
                        let rawVal = item.company?.address?.state || item.company_state;
                        return normalizeState(rawVal);
                    }).filter(state => state && state !== "")
                )].sort();
                const event = new CustomEvent('CMD_UPDATE_STATES', { detail: uniqueProductStates });
                window.dispatchEvent(event);
            }

            // Filtro Categoría
            if (activeTab === 'products' && selectedCategories.length > 0) {
                data = data.filter(item => selectedCategories.includes(item.category.name));
            }

            // Filtro Ubicación
            if (activeTab === 'products' && selectedStates.length > 0) {
                data = data.filter(item => {
                    let rawVal = item.company?.address?.state || item.company_state;
                    const normalized = normalizeState(rawVal);
                    return selectedStates.includes(normalized);
                });
            }

            // Filtro Certificación
            if (activeTab === 'products' && filterCerts && filterCerts.trim() !== "") {
                const certQuery = filterCerts.toLowerCase().trim();
                data = data.filter(item => {
                    const allCerts = [
                        item.titles,
                        item.titles2, 
                        item.company?.titles
                    ].map(t => (t || "").toLowerCase()).join(" ");
                    return allCerts.includes(certQuery);
                });
            }

            setTotal(data.length);
            const _array = data.slice(_page * filterInfo.pageSize, (_page * filterInfo.pageSize) + filterInfo.pageSize);
            setProductsState(_array);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            console.error(e);
            setProductsState([]);
        }

    }

    const changePage = (currentPage) => {
        window.scrollTo(0, 0);
        setPage(currentPage);
        if(activeTab === 'companies'){
            getCompanies(currentPage - 1, selectedStates);
        } else {
            getActiveProducts(currentPage - 1);
        }
    }

    const changeTableSize = (newSize) => {
        tokenArray = [];
        setPage(1);
        setFilterInfo(newSize, filterInfo.minPrice, filterInfo.maxPrice, filterInfo.customAllowed, filterInfo.warranty, filterInfo.minBuy, filterInfo.categories);
    }

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setPage(1);
        setSortBy('relevant');
        setFilterCerts('');
        
        // Limpiamos el filtro de estado al cambiar de tab si se desea
        setSelectedStates([]);
        clearSelectedCategories();

        const event = new CustomEvent('searchTabChanged', { detail: tab });
        window.dispatchEvent(event);

        if (tab === 'companies') getCompanies(0, selectedStates);
        else getActiveProducts(0);
    }

    const handleChatWithUs = async (productOwner, productPage) => {
        setLoading(true);
        try {
            const u = await Auth.currentAuthenticatedUser();
            const filter = {
                cognito_id: { eq: productOwner }
            }
            const pager = new PagerQuery(listUsers, { filter }, Object.keys({ listUsers }));
            const resultCompanyUser = await pager.searchPrivateData();

            const chatResult = await generateProductChat(CHAT_PRODUCT_MESSAGE, productPage, t, user, resultCompanyUser.data.listUsers.items[0]);
            if (chatResult === true) {
                history.push("/my-chats/1");
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
            if (e === 'The user is not authenticated') {
                setViewModalUser(true);
            }
        }
    }

    //if (loading)
      //  return <Loading fullscreen={loading} />; //

    const isNoResults = (activeTab === 'products' && total === 0) || (activeTab === 'companies' && totalCompanies === 0);

    return (
        <>
            <Layout.Row type="flex" span="24">
                <Layout.Col offset="1" xs="24" sm="22" md="22" lg="22">
                    <h2 className="text-left">{mainInfo?.title}</h2>
                    <label className="text-justify">{mainInfo?.description}</label>
                </Layout.Col>
            </Layout.Row>

            {/*  SECCIÓN DE PESTAÑAS (TABS) */}
            <Layout.Row type="flex" span="24">
                <Layout.Col offset="1" xs="24" sm="22" md="22" lg="22">
                    <div style={{ marginRight: '10px', fontWeight: 'bold', paddingTop: '5px' }}>
                        browse by:
                    </div>
                    <div style={{ display: 'flex', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                        <div
                            onClick={() => { handleTabChange('products') }}
                            style={{
                                cursor: 'pointer',
                                marginRight: '20px',
                                fontWeight: activeTab === 'products' ? 'bold' : 'normal',
                                color: activeTab === 'products' ? '#FF6D73' : '#333',
                                borderBottom: activeTab === 'products' ? '2px solid #FF6D73' : 'none'
                            }}
                        >
                            <span style={{ fontSize: '24px' }}>Products</span>
                            <span style={{ fontSize: '18px', marginLeft: '6px' }}>[{total}]</span>
                        </div>
                        <div
                            onClick={() => { handleTabChange('companies') }}
                            style={{
                                cursor: 'pointer',
                                fontWeight: activeTab === 'companies' ? 'bold' : 'normal',
                                color: activeTab === 'companies' ? '#FF6D73' : '#333',
                                borderBottom: activeTab === 'companies' ? '2px solid #FF6D73' : 'none'
                            }}
                        >
                            <span style={{ fontSize: '24px' }}>Companies</span>
                            <span style={{ fontSize: '18px', marginLeft: '6px' }}>[{totalCompanies}]</span>
                        </div>
                    </div>
                </Layout.Col>
            </Layout.Row>

            {viewSubCategoryDescription && (
                <Layout.Row style={{ marginTop: '10px' }} type="flex" span="24">
                    <Layout.Col offset="1" xs="24" sm="22" md="22" lg="22">
                        <SearchSubCategoryDescription title={titleAndDescription.title} description={titleAndDescription.description} />
                    </Layout.Col>
                </Layout.Row>
            )}
            <ProductBanner setViewModalUser={setViewModalUser} modalVisible={viewModalUser} title={''} />

            {/* Filtros (productos, o empresas) */}
            <Layout.Row type="flex" span="24">
                <Layout.Col offset="1" xs="24" sm="22" md="22" lg="22">

                    {!mainInfo?.title && (
                        <FilterHeader
                            filterCerts={filterCerts}
                            setFilterCerts={setFilterCerts}
                            sortBy={sortBy}
                            setSortBy={setSortBy}
                            t={t}
                            activeTab={activeTab} 
                            onSearch={() => {
                                if (activeTab === 'companies') {
                                    getCompanies(0, selectedStates);
                                } else {
                                    getActiveProducts(0);
                                }
                            }}
                        />
                    )}

                </Layout.Col>
            </Layout.Row>

            <Layout.Row type="flex" span="24">
                <Layout.Col offset="1" xs="24" sm="22" md="22" lg="22">

                    {/* CASO 1: Pestaña Productos */}
                    {activeTab === 'products' && productsState && productsState.map((element, i) => (
                        <div key={element.id}>
                            <ResultCard
                                handleChatWithUs={handleChatWithUs}
                                removeFromFavorites={removeFromFavorites}
                                addToFavorites={addToFavorites}
                                favorites={favorites}
                                t={t}
                                product={element}
                            />
                            <br />
                        </div>
                    ))}

                    {/* CASO 2: Pestaña Empresas */}
                    {activeTab === 'companies' && companiesState && companiesState.map((company, i) => (
                        <div key={company.id || i}>
                            <CompanyResultCard
                                company={company}
                                t={t}
                                handleChatWithUs={handleChatWithUs}
                            />
                            <br />
                        </div>
                    ))}

                    {/* CASO 3: Sin Resultados */}
                    {isNoResults && (
                        <Survey surveyTitle={t('product.search-result.no-results-title')} />
                    )}

                </Layout.Col>
            </Layout.Row>

            <Layout.Row type="flex" span="24">
                <Layout.Col style={{ textAlign: 'center' }} xs="21" sm="22" md="22" lg="22">
                    {
                        <Pagination
                            layout="sizes, prev, pager, next"
                            total={activeTab === 'products' ? total : totalCompanies}
                            pageSizes={[5, 25, 50, 100]}
                            onCurrentChange={changePage}
                            onSizeChange={changeTableSize}
                            currentPage={page}
                            pageSize={filterInfo.pageSize} />

                    }
                </Layout.Col>
            </Layout.Row>
            <Layout.Row type="flex" span="24">
                <Layout.Col offset="1" xs="24" sm="22" md="22" lg="22">
                </Layout.Col>
            </Layout.Row>
        </>
    );
}

export default SearchResultNG;